import { SelectType } from 'ui/common/select/types';

export const isHierarchy = (selectType: SelectType) => {
  return selectType === SelectType.singleHierarchy || selectType === SelectType.multipleHierarchy;
};

export const isMultiple = (selectType: SelectType) => {
  return selectType === SelectType.multipleHierarchy
    || selectType === SelectType.multiple;
};

export const isSingle = (selectType: SelectType) => {
  return selectType === SelectType.singleHierarchy
    || selectType === SelectType.single;
};
